import * as yup from 'yup';
import { error } from '../text';

const passwordMixed = new RegExp(
  ['(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9!-/:-@[-`{-~]{6,}$'].join(''),
);
const emailValidation = yup
  .string()
  .lowercase()
  .required(error.required)
  .email(error.email)
  .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, error.email)
  .max(250, error.below250);

const passwordValidation = yup
  .string()
  .required(error.required)
  .min(6, error.min)
  .max(250, error.below250)
  .matches(passwordMixed, error.mixed);

const LoginPasswordValidation = yup.string().required(error.required);

export const userLoginSchema = yup.object().shape({
  email: emailValidation,
  password: LoginPasswordValidation,
});

export const userInviteMailSchema = yup.object().shape({
  email: emailValidation,
  role: yup.bool().oneOf([true, false], error.required).required(error.required),
});

export const authRegisterSchema = yup.object().shape({
  email: emailValidation,
  privacyCheck: yup.bool().oneOf([true], error.agreeToTerms),
});

export const PasswordChangeSchema = yup.object().shape({
  email: yup.string().nullable().notRequired(), // disabledで値を持っていないことになるためnull許可
  password: passwordValidation,
  passwordConfirm: passwordValidation.oneOf([yup.ref('password')], 'パスワードが一致しません'),
});

export const LoggedInPasswordChangeSchema = yup.object().shape({
  currentPassword: yup.string().required(error.required),
  newPassword: passwordValidation,
  newPasswordConfirm: passwordValidation.oneOf(
    [yup.ref('newPassword')],
    'パスワードが一致しません',
  ),
});

export const reRegisterPasswordSchema = yup.object().shape({
  email: emailValidation,
});

// clientStaffEditSchema は validation/users.ts に同名の定義があり、
// 利用側（StaffEditCard）はそちらを参照しているため、重複定義をここから削除した（#3071）
